import { AccessoryCategory, PositionValues } from '../Constants';
import { ImageDetails } from './image-details.dto-response';
import { InventoryDtoResponse, InventoryDetailDtoResponse } from './inventory.dto-response';
import { LabourDtoResponse } from './labour.dto-response';
import { ProductCardDetailsDtoResponse } from './product-card-details.dto-response';
import { TirePressureDtoResponse } from './tire-pressure.dto-response';
import { PriceScalesDtoResponse } from './price-scales.dto-response';
import { TireSideWallDtoResponse } from './tire-sidewall.dto-response';
import { ComponentDtoResponse } from './component-dto-response';
import { LeadTimeDtoResponse } from './lead-time-dto-response';

export class ProductCardDtoResponse {
  title: string; // stagger title (FRONT - BR04)
  // djb:added to allow non stagger titles (BR04)
  titleRaw: string;
  productImage: ImageDetails;
  retailPrice: string;
  specialPrice: string;
  customerPrice: string;
  dealerCost: string;
  landedCost: string;
  shortSKU: string;
  longSKU: string;
  pairNo: string;
  details: ProductCardDetailsDtoResponse;
  isNew: boolean;
  isPreLaunch: boolean;
  isSpecial: boolean;
  labours: LabourDtoResponse[];
  inventory: InventoryDtoResponse;
  onHandDetails: InventoryDetailDtoResponse[];
  isDirectFit?: boolean;
  isHubCentric?: boolean;
  isAggressiveFitment?: boolean;
  isDrilled?: boolean;
  isBlem: boolean;
  isWinterWheel: boolean;
  hasAlternateWarehouseMtl: boolean;
  hasAlternateWarehouseCal: boolean;
  hasAlternateWarehousePic: boolean;
  icons: ImageDetails[];
  warningNotes: string[];
  position: PositionValues;
  qtyPerWheel: number;
  tirePressure: TirePressureDtoResponse[];
  pcd: string;
  finish: string;
  finishAbreviation: string;
  summerOrWinterTire: string;
  // djb:refactor-studdable, snowflake and runflat should be boolean
  // since these are already localized in webapi and difficult to dereference for UI logic
  studdable: string;
  snowflake: string;
  icegrip: string;
  runflat: string;
  iconUrl: string;
  quantity: number;
  defaultWarehouse: string;
  productStatus: string;
  openEnded: number;
  // djb:refactor to use Contants.Enum
  // djb:warning-this exposes deep discrepencies between Categories db and internal/manual HardwareAccessoryTypes
  // When changed back to AccessoryCategory, the compiler will point the problems
  // this design issue needs to be addressed at some point
  //accessoryType: number;
  accessoryType: AccessoryCategory;
  qtyBaseUOfM: number;
  confirmedFitment: boolean;
  extensionCapRequired: boolean;
  extensionCapPrice?: number;
  tireType: string;
  tooltipPlacement: string;
  priceScales: PriceScalesDtoResponse[];
  bookingPrice: string;
  hasBookingPrice: boolean;
  englishDescription: string;
  frenchDescription: string;
  isDualSidewall: boolean;
  tireSideWalls: TireSideWallDtoResponse[];
  isNationalAccountItem: boolean;
  tireLeadTimeDelayMTL: LeadTimeDtoResponse;
  tireLeadTimeDelayCAL: LeadTimeDtoResponse;
  tireLeadTimeDelayPIC: LeadTimeDtoResponse;
  wheelDrillLeadTimeDelay: LeadTimeDtoResponse;
  stdEmblem: string;
  stdCap: string;
  capScrewNo: string;
  totalNATireNetPrice: string;
  hasNATire: boolean;
  kitLandedCostTotal: string;
  kitLandedCostTotalWithOutNATires: string;
  mtL3PLLeadTimeDelay: LeadTimeDtoResponse;
  discountPercent?: number;
  rft: string;
  componentList: ComponentDtoResponse[];
  hasSpaceForWeights?: boolean;
  alternateProductList: string[];
  matchingPercentage: string;
  bestFitment: boolean;
  // WIP - VOLUME DISCOUNT
  volumeDiscount: string;
  volumeDiscountEligible: boolean;
  mtlLeadTimeDelayTooltip: string;
  calLeadTimeDelayTooltip: string;
  picLeadTimeDelayTooltip: string;
  showMTLLeadTimeAsterisk: boolean = true;
  showCALLeadTimeAsterisk: boolean = true;
  showPICLeadTimeAsterisk: boolean = true;
  showMTLAProductLeadTime: boolean = false;
  showCALAProductLeadTime: boolean = false;
  showPICAProductLeadTime: boolean = false;
  has3PL: boolean;
  featured: boolean;
  freeWMB: boolean;

  // djb:easier to add this to the DTO and faster than lookup in the component
  //get shortSkuLabel(): string {
  //  return "FC.Label.Sku";
  //}
  //get longSkuLabel(): string {
  //  if (this.accessoryType === AccessoryCategory.Studding || this.accessoryType === AccessoryCategory.Mounting) {
  //    return "FC.Label.Part";
  //  }
  //  return "FC.Label.Service";
  //}
}
